import { computed } from "vue";

import { useDeviceStore } from "@/entities/device/model";
import { useEvaluationStore } from "@/entities/evaluation/model";

/** Множитель B2B к цене выкупа для частного лица (B2C): +5% */
const B2B_MULTIPLIER = 1.05;
/** Для "PC Notebook Commercial": +10% */
const B2B_COMMERCIAL_NOTEBOOK_MULTIPLIER = 1.1;

/**
 * Цена выкупа для компании: оценка из API (B2C) с наценкой по категории устройства.
 * Без копеек: дробная часть отбрасывается.
 */
export function useB2bPrice() {
    const deviceStore = useDeviceStore();
    const evaluationStore = useEvaluationStore();

    const b2bPrice = computed(() => {
        const b2cPrice = evaluationStore.tradeInPrice;

        if (b2cPrice === null) return null;

        const multiplier = deviceStore.isCommercialNotebook
            ? B2B_COMMERCIAL_NOTEBOOK_MULTIPLIER
            : B2B_MULTIPLIER;

        return Math.trunc(b2cPrice * multiplier);
    });

    return {
        b2bPrice,
    };
}
